/**
 * src/shell/config/channel-module-map.ts
 *
 * Explicit Canonical Mapping of Channel IDs to Module Manifest IDs.
 * Used by Sidebar and Router to enforce runtime navigation boundaries.
 */

export const CHANNEL_MODULE_MAP: Record<string, string> = {
  // Ecommerce
  commerce: 'com.mesh.commerce',
  pos: 'com.mesh.pos',
  kiosk: 'com.mesh.kiosk',
  inventory: 'com.mesh.inventory',

  // Finance
  'sales-pipeline': 'com.mesh.crm',
  invoicing: 'com.mesh.invoicing',
  payroll: 'com.mesh.payroll',
  ledger: 'com.mesh.ledger',
  'authority-item-mappings': 'com.mesh.authority',

  // Media
  gallery: 'com.mesh.gallery',
  cms: 'com.mesh.cms',
  'cms-translation': 'com.mesh.cms-translation',

  // PM
  general: 'com.mesh.chat',
  scrum: 'com.mesh.action-planner',
  'lifecycle-test': 'com.mesh.lifecycle-test',

  // Ops & AI
  'ai-demo': 'com.mesh.agents',
  'knowledge-priming': 'com.mesh.knowledge',
  'investor-faq': 'com.mesh.investor',
  'engineering-ops': 'com.mesh.ops',
};

export function isChannelEnabledForProfile(channelId: string, enabledModuleIds: string[]): boolean {
  const moduleId = CHANNEL_MODULE_MAP[channelId];
  if (!moduleId) return true; // Default unmapped channels allowed
  return enabledModuleIds.includes(moduleId);
}
